export const getItemDescription = (groupName, itemDescription) => {
    if (!groupName) return itemDescription;
    let groupPrefix = `${groupName}: `;
    return itemDescription.replace(groupPrefix, "");
}